export const _setIsProfB1DataLoaded = (state, action) => {
  state.isProfB1DataLoaded = action.payload;
};

export const _setCountyOfLastLegalResidenceId = (state, action) => {
  state.countyOfLastLegalResidenceId = action.payload;
};

export const _setDateReceivedCDC = (state, action) => {
  state.dateReceivedCDC = action.payload;
};

export const _setLengthOfTermInYrsAndMos = (state, action) => {
  state.lengthOfTermInYrsAndMos = action.payload;
};

export const _setLengthOfTermInYrs = (state, action) => {
  state.lengthOfTermInYrs = action.payload;
};
export const _setLengthOfTermInMos = (state, action) => {
  state.lengthOfTermInMos = action.payload;
};

export const _setSecondStrike = (state, action) => {
  state.secondStrike = action.payload;
};

export const _setCommitmentOffenses = (state, action) => {
  state.commitmentOffenses = action.payload;
};
export const _setExpectedPrisonReleaseDate = (state, action) => {
  state.expectedPrisonReleaseDate = action.payload;
};

export const _setControllingDischargeDate = (state, action) => {
  state.controllingDischargeDate = action.payload;
};

export const _setComments = (state, action) => {
  state.comments = action.payload;
};

export const _setReleaseDate = (state, action) => {
  state.releaseDate = action.payload;
};

export const _setControllingDchDate = (state, action) => {
  state.controllingDchDate = action.payload;
};
export const _setEPRD = (state, action) => {
  state.EPRD = action.payload;
};
export const _setRRD = (state, action) => {
  state.RRD = action.payload;
};
export const _setPED = (state, action) => {
  state.PED = action.payload;
};
export const _setCDD = (state, action) => {
  state.CDD = action.payload;
};
export const _setCDD_MAX = (state, action) => {
  state.CDD_MAX = action.payload;
};
export const _setHighControlSupervision = (state, action) => {
  state.highControlSupervision = action.payload;
};
export const _setH11590NarcoticRegistration = (state, action) => {
  state.h11590NarcoticRegistration = action.payload;
};
export const _setPC296ViolentOrSeriousOffenderNotification = (
  state,
  action
) => {
  state.pC296ViolentOrSeriousOffenderNotification = action.payload;
};
export const _setCity = (state, action) => {
  state.city = action.payload;
};
export const _setParoleRegion = (state, action) => {
  state.paroleRegion = action.payload;
};
export const _setHistoryOfConvictions = (state, action) => {
  state.historyOfConvictions = action.payload;
};
export const _setRSuffixInCentralFile = (state, action) => {
  state.rSuffixInCentralFile = action.payload;
};
export const _setRSuffixExplination = (state, action) => {
  state.rSuffixExplination = action.payload;
};
export const _setP290SexRegistration = (state, action) => {
  state.participant.p290SexRegistration = action.payload;
};
export const _setP457_1ArsonRegistration = (state, action) => {
  state.participant.p457_1ArsonRegistration = action.payload;
};
